import * as React from 'react';

const SvgActionCopyFill = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M18 6H2v16h16V6Z" }),
  React.createElement("path", { fill: "#2D2E2E", d: "M6 2v2h14v14h2V2H6Z" })
);

export { SvgActionCopyFill as default };
//# sourceMappingURL=ActionCopyFill.es.js.map
